import { formatDataQueryFieldName } from './data-query-format.utils';

export type DataQueryColumnLabels = {
  count: string;
  value: string;
  week: string;
  month: string;
  date: string;
  method: string;
  endpoint: string;
  finding: string;
  signal: string;
  execution: string;
  request: string;
  status: string;
  stage: string;
  severity: string;
  category: string;
};

function groupFieldLabel(field: string, labels: DataQueryColumnLabels): string {
  switch (field) {
    case 'status':
      return labels.status;
    case 'stage':
      return labels.stage;
    case 'severity':
      return labels.severity;
    case 'category':
      return labels.category;
    case 'endpointId':
      return labels.endpoint;
    case 'signalId':
      return labels.signal;
    case 'findingId':
      return labels.finding;
    default:
      return formatDataQueryFieldName(field);
  }
}

export type DataQueryTableColumns = {
  leading?: string;
  primary: string;
  secondary?: string;
};

export function resolveGroupTableColumns({
  groupBy,
  labels,
}: {
  groupBy?: { field: string; dateBucket?: string };
  labels: DataQueryColumnLabels;
}): DataQueryTableColumns {
  if (groupBy?.dateBucket === 'week') {
    return { primary: labels.week, secondary: labels.count };
  }

  if (groupBy?.dateBucket === 'month') {
    return { primary: labels.month, secondary: labels.count };
  }

  if (groupBy?.dateBucket === 'day') {
    return { primary: labels.date, secondary: labels.count };
  }

  if (groupBy?.field) {
    return {
      primary: groupFieldLabel(groupBy.field, labels),
      secondary: labels.count,
    };
  }

  return { primary: labels.value, secondary: labels.count };
}

export function resolveListTableColumns({
  collection,
  labels,
}: {
  collection?: string;
  labels: DataQueryColumnLabels;
}): DataQueryTableColumns {
  switch (collection) {
    case 'endpoints':
      return { leading: labels.method, primary: labels.endpoint };
    case 'findings':
      return { primary: labels.finding, secondary: labels.severity };
    case 'signals':
      return { primary: labels.signal, secondary: labels.category };
    case 'executions':
      return { primary: labels.execution, secondary: labels.status };
    case 'harEntries':
      return { leading: labels.method, primary: labels.request };
    default:
      return { primary: labels.value };
  }
}
